import { episodeManager } from './managers';
import moment from 'moment';
import isNull from 'lodash/isNull';
import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';

window.URL = window.URL || window.webkitURL;
window.AudioContext = window.AudioContext || window.webkitAudioContext;

// extra minutes that a scheduled publishing is valid
export const LATER_PUBLISH_MINUTE_OFFSET = 2;
export const PAGINATED_EPISODE_LIMIT = 20;
export const PAGINATED_RATINGS_LIMIT = 20;
export const EPISODE_REALTIME_PROPKEYS = [
  'episodeState',
  'publishOn',
  'audioProcessing',
  'editedDuration',
  'editedUrl',
  'emailListeners',
  'last_update',
];

export const isLaterDate = date => date.isBefore(moment());
export const isLaterDateBefore = (date, before) => moment(date).isBefore(moment(before));
export const isValidPublishDate = (unixDate, predicate = null) => {
  const date = moment.unix(unixDate);
  const now = isFunction(predicate) ? predicate() : moment().startOf('hour');
  return !isLaterDateBefore(date, now);
};

export const isEpisodeScheduled = ({ publishOn = null }) => !isNull(publishOn);
export const getFormattedSchedule = unixDate => moment.unix(unixDate).format('MMM DD YYYY hh:mm A');
export const getFormattedPublished = unixDate => // moment.unix(unixDate).format('MMM DD YYYY');
  moment.unix(unixDate).format(process.env.NODE_ENV === 'production'? 'MMM DD YYYY' : 'MMM DD YYYY HH:mm');
export const getTimeFromNow = unixDate => moment.unix(unixDate).fromNow();
export const createTimeDiff = (unixFirst, unixSend) => {
  const start = moment.unix(unixFirst);
  const end = moment.unix(unixSend);
  return moment.duration(end.diff(start));
};

export const getAudioDuration = file => {
  return new Promise(resolve => {
    let audio = document.createElement('audio');
    audio.onloadedmetadata = () => {
      window.URL.revokeObjectURL(audio.src);
      let duration = audio.duration;
      resolve(duration);
    };

    audio.addEventListener('error', () => resolve(0));

    audio.preload = 'auto';
    audio.src = window.URL.createObjectURL(file);
  });
};

export const getPublishedAtUnix = (publishedAt = '') => {
  return !isEmpty(publishedAt) ? moment(publishedAt).unix() : '';
};

export const episodeHasErrorStatusState = episode => {
  const { episodeState = '' } = episode;
  return (episodeState || '').slice(0, 6) === 'Error:';
};

export const extractEpisodeStatusState = statusState => (statusState || '').slice(7, 32);
export const getEpisodeStatusState = episodeId => {
  return new Promise(async resolve => {
    try {
      const episodeState = await episodeManager.getProp(episodeId, 'episodeState', '');
      resolve(episodeState);
    } catch (err) {
      resolve('');
    }
  });
};

export const getEpisodeFirebase = episodeId => {
  return new Promise(async resolve => {
    try {
      console.log('getting firebase data', episodeId);

      const episode = await episodeManager.getById(episodeId);
      if (isEmpty(episode)) {
        throw new Error('The track does not exist');
      }

      resolve(episode);
    } catch (err) {
      resolve({});
    }
  });
};

export const extractRealTimePropsFromEpisode = episode => {
  return EPISODE_REALTIME_PROPKEYS.reduce((prev, key) => {
    prev[key] = key in episode ? episode[key] : null;
    return prev;
  }, {});
};

export const episodeHasRealtimeProps = episode => {
  const episodeKeys = Object.keys(episode);
  return EPISODE_REALTIME_PROPKEYS.every(key => {
    return episodeKeys.includes(key);
  });
};

export const applyEpisodeRealtimeProps = episode => {
  return new Promise(async resolve => {
    const { episodeId } = episode;
    const nepisode = await getEpisodeFirebase(episodeId);
    const extracted = extractRealTimePropsFromEpisode(nepisode);
    console.log('extracted', extracted);
    resolve({
      ...episode,
      ...extracted,
    });
  });
};
